ICONS_PER_ROUND = 20;
MILLISECONDS_PER_ICON = 2500;
MILLISECONDS_BETWEEN_ICONS = 500
SHOW_AC_FORM_AFTER_X_ROUNDS = 10;
score = 0;
iconNumber = 0;
expectedUserInput = "";
givenUserInput = "";


function createRandomIconArray() {
	let items = [];
	for (let i = 0; i < ICONS_PER_ROUND; i++) {
		items.push(Math.floor(Math.random() * icons.length));
	}

	return items;
}

async function runRound() {
	randomRule = choseRandomRule();
	await viewRule(randomRule);
	viewUserInteractionButtons();
	randomIcons = createRandomIconArray();
	for (let i = 0; i < ICONS_PER_ROUND; i++) {

		if (i >= SHOW_AC_FORM_AFTER_X_ROUNDS) {
			showACForm()
		}

		updateStatusFooter(`Symbol ${i+1} von ${ICONS_PER_ROUND} | Punktestand: ${score*100}`);
		
		if (i >= randomRule.offset) {
			unlockUserInput();
			
		}


		currentlyViewedIconIndex = i;
		iconIndexWithOffset = randomIcons[i - randomRule.offset];

		if (
			iconsAreTheSame(
				currentlyViewedIconIndex,
				iconIndexWithOffset,
				randomIcons
			)
		) {
			expectedUserInput = "same";
		} else {
			expectedUserInput = "different"
		};

		
		await viewIcon(icons[randomIcons[i]]);
		resetUserInput();

		lockUserInput();
		
	}
	endRound();
}





function iconsAreTheSame(
	currentlyViewedIconIndex,
	iconIndexWithOffset,
	randomIcons
) {
	if (currentlyViewedIconIndex < randomRule.offset) {
		console.log("🟡 not comparing as index is smaller than offset");
		return;
	}

	console.log(
		`comparing if the currently viewed icon at index ${currentlyViewedIconIndex} is the same as the icon showed ${randomRule.offset} steps before.`
	);
	currentlyViewedIconObject = icons[randomIcons[currentlyViewedIconIndex]];
	console.log("currently viewed icon object", currentlyViewedIconObject);

	console.log("getting icon object viewed X steps before");
	iconWithOffsetObject = icons[iconIndexWithOffset];
	console.log("icon with offset object", iconWithOffsetObject);

	if (currentlyViewedIconObject.id === iconWithOffsetObject.id) {
		console.log("same icon");
		return true;
	} else {
		console.log("different icon");
		return false;
	}
}

function endRound() {
	console.log("Round ended");	
	iconViewContainer = document.getElementById("icon-view-container")
	iconViewContainer.innerHTML = "Übung abgeschlossen. 🎉";
}

lockUserInput();
